export default __webpack_public_path__ + "media/images/down_arrow-503c5598bc18437432a279c2dad21f8b.png";